import { Component, OnInit, ViewChild, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Subscription, forkJoin } from 'rxjs';
import { LayoutUtilsService, MessageType } from '../../../../../core/_base/crud';
import { SubheaderService } from '../../../../../core/_base/layout';
import { AuthService } from '../../../../../core/auth/_services/auth.service';

@Component({
    selector: 'kt-blocked-users-list',
    templateUrl: './blocked-users-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockedUsersListComponent implements OnInit, OnDestroy {
    
    // DataSources
    userDataSource: MatTableDataSource<any>;
    ipDataSource: MatTableDataSource<any>;

    // Columns
    userDisplayedColumns = ['id', 'username', 'email', 'total_strikes', 'last_attempt', 'actions'];
    ipDisplayedColumns = ['ip_address', 'reason', 'blocked_at', 'actions'];

    @ViewChild('userPaginator', {static: true}) userPaginator: MatPaginator;
    @ViewChild('userSort', {static: true}) userSort: MatSort;
    @ViewChild('ipPaginator', {static: true}) ipPaginator: MatPaginator;
    @ViewChild('ipSort', {static: true}) ipSort: MatSort;

    loading = false;
    private subscriptions: Subscription[] = [];

    constructor(
        private authService: AuthService, // Assumes your security methods are here
        private layoutUtilsService: LayoutUtilsService,
        private subheaderService: SubheaderService,
        private cdr: ChangeDetectorRef) {}

    ngOnInit() {
        this.subheaderService.setTitle('Security & Blocked Lists');
        this.loadData();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(el => el.unsubscribe());
    }

    /**
     * Load both Users and IPs from the security_management.php endpoint
     */
    loadData() {
        this.loading = true;
        // Adjust this call to match your AuthService method for security_management.php
        const sub = this.authService.getSecurityBlockedLists().subscribe(
            res => {
                this.userDataSource = new MatTableDataSource(res.users);
                this.userDataSource.sort = this.userSort;
                this.userDataSource.paginator = this.userPaginator;

                this.ipDataSource = new MatTableDataSource(res.ips);
                this.ipDataSource.sort = this.ipSort;
                this.ipDataSource.paginator = this.ipPaginator;

                this.loading = false;
                this.cdr.detectChanges();
            },
            err => {
                this.loading = false;
                this.layoutUtilsService.showActionNotification('Error loading security data', MessageType.Read);
            }
        );
        this.subscriptions.push(sub);
    }

    /**
     * UNBLOCK USER ACTION
     */
    unblockUser(userId: number) {
        const _title = 'Unblock User';
        const _description = 'Are you sure you want to reactivate this user and clear their security strikes?';
        const _waitDesciption = 'Updating account status...';
        const _successMsg = 'User has been successfully unblocked.';

        const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
        dialogRef.afterClosed().subscribe(res => {
            if (!res) return;

            this.authService.processSecurityAction('unblock_user', userId).subscribe(() => {
                this.layoutUtilsService.showActionNotification(_successMsg, MessageType.Update);
                this.loadData();
            });
        });
    }

    /**
     * UNBLOCK IP ACTION
     */
    unblockIp(ipAddress: string) {
        const _title = 'Whitelist IP';
        const _description = `Are you sure you want to unblock IP: ${ipAddress}?`;
        
        const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, 'Processing...');
        dialogRef.afterClosed().subscribe(res => {
            if (!res) return;

            this.authService.processSecurityAction('unblock_ip', ipAddress).subscribe(() => {
                this.layoutUtilsService.showActionNotification('IP Whitelisted', MessageType.Update);
                this.loadData();
            });
        });
    }

    applyUserFilter(filterValue: string) {
        this.userDataSource.filter = filterValue.trim().toLowerCase();
    }
}